<div class="sticky-div">
<app-appointments-filter (searchChange)="searchFilter = $event"></app-appointments-filter>
</div>
<div class="content">
	<table mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)">

		<ng-container matColumnDef="appointmentId">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Appt Id</th>
			<td mat-cell *matCellDef="let row" >
				<div class="mrn sub">{{ row.appointmentId}}</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="surveyId">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Survey Id</th>
			<td mat-cell *matCellDef="let row" >
				<div class="mrn sub">{{ row.surveyId}}</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="patientId">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Patient Id</th>
			<td mat-cell *matCellDef="let row">
				<div class="mrn sub">{{ row.patientId}}</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="mrn">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>MRN</th>
			<td mat-cell *matCellDef="let row">
				<div class="mrn sub">{{ row.mrn}}</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="firstName">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>First Name</th>
			<td mat-cell *matCellDef="let row">
				<div class="mrn sub">{{ row.firstName}}</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="lastName">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Last Name</th>
			<td mat-cell *matCellDef="let row">
				<div class="mrn sub">{{ row.lastName}}</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="organizationId">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Org Id</th>
			<td mat-cell *matCellDef="let row">
				<div class="mrn sub">{{ row.organizationId}}</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="organizationName">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Org  Name</th>
			<td mat-cell *matCellDef="let row">
				<div class="mrn sub">{{ row.organizationName}}</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="appointmentTime">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
			<td mat-cell *matCellDef="let row">
				<div class="mrn sub">{{ formatDate(row.appointmentTime)}}</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="appointmentType">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
			<td mat-cell *matCellDef="let row">
				<div class="mrn sub">{{ row.appointmentType}}</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="providerId">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Provider Id</th>
			<td mat-cell *matCellDef="let row">
				<div class="mrn sub">{{ row.providerId}}</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="providerFirstName">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>First Name</th>
			<td mat-cell *matCellDef="let row">
				<div class="mrn sub">{{ row.providerFirstName}}</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="providerLastName">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Last Name</th>
			<td mat-cell *matCellDef="let row">
				<div class="mrn sub">{{ row.providerLastName}}</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="userAgent">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>User Agent</th>
			<td mat-cell *matCellDef="let row">
				<div class="mrn sub">{{ row.userAgent}}</div>
			</td>
		</ng-container>

		<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
		<tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="goto(row)" >
		</tr>

	</table>

</div>
